(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
